query childCompanies {
    childCompanies {
        id
        name
        address {
            street
            city
            zip
            country
        }
        ambassador {
            firstname
            lastname
            image {
                url
            }
        }
    }
}
